// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"logo_logoContainer__G2t_N","logoSVG":"logo_logoSVG___m64N"};